// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"346":"90061d2c","633":"7fbb835f","816":"776bd865"}[chunkId] + ".chunk.js";
};